// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2ZyIn","content":"RecentSearches_content__1ijzr"};